import { render, staticRenderFns } from "./SenderNoticeList.vue?vue&type=template&id=48de4d6c&scoped=true&"
import script from "./SenderNoticeList.vue?vue&type=script&lang=js&"
export * from "./SenderNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de4d6c",
  null
  
)

export default component.exports